import { Entransito } from './../models/entransito';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS } from 'src/app/config/config';

@Injectable({
  providedIn: 'root'
})
export class EntransitoService {

  constructor(
    public http: HttpClient
  ) { }



  agregar( entransito: Entransito ) {
    let url = URL_SERVICIOS + '/entransito';
    return this.http.post ( url , entransito)
    .map (( resp: any ) => {
       console.log (resp);
    });

  }

  listado( idempresa: string ) {
    let url = URL_SERVICIOS + '/entransito/' + idempresa;
    return this.http.get ( url)
    .map ( (resp: any) => resp);


  }

  borra( idregistro: string ) {
    let url = URL_SERVICIOS + '/entransito/borrarentransito/' + idregistro;
    return this.http.get ( url);
   // .map ( (resp: any) => resp);


  }

  borraagencias( idregistro: string, tipolic: string) {
    let url = URL_SERVICIOS + '/entransito/borrarentransitoagencias/' + idregistro + '/' + tipolic;
    return this.http.get ( url);
   // .map ( (resp: any) => resp);


  }

}
